module.exports = __webpack_public_path__ + "static/media/38.0ba01b93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/38.jpg
// module id = 571
// module chunks = 0